import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalBase } from 'morgana';
import { PracticePayPaymentService } from '@core/practice-pay-payment/practice-pay-payment.service';
import { ToasterService } from '@core/toaster/toaster.service';
import { PracticePayInitializeStoreCardSessionRequest } from '@gandalf/model/practice-pay-initialize-store-card-session-request';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';

export interface PracticePaySaveCardModalData {
	personId: number;
	practiceLocationId: number;
}

@Component({
	selector: 'pms-practice-pay-save-card-modal',
	templateUrl: './practice-pay-save-card-modal.component.html',
	styleUrls: ['./practice-pay-save-card-modal.component.scss'],
	standalone: false,
})
export class PracticePaySaveCardModalComponent extends ModalBase<PracticePaySaveCardModalData, boolean> implements OnInit {

	@ViewChild('modal')
	modal: DialogComponent;

	iframeUrl: SafeResourceUrl;
	isLoading = true;
	errors: string[] = [];

	constructor(
		private practicePayPaymentService: PracticePayPaymentService,
		private toasterService: ToasterService,
		private sanitizer: DomSanitizer,
	) {
		super();
	}

	ngOnInit(): void {
		this.initializeStoreCardSession();
	}

	initializeStoreCardSession() {
		this.isLoading = true;
		this.errors = [];
		const request = new PracticePayInitializeStoreCardSessionRequest();
		request.personId = this.data.personId;
		request.practiceLocationId = this.data.practiceLocationId;
		this.practicePayPaymentService.initializeStoreCardSession(request)
			.subscribe({
				next: (url: string) => {
					this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
					this.isLoading = false;
				},
				error: (error: HttpErrorResponse) => {
					this.isLoading = false;
					const errorMessage = error?.error?.message
						|| 'Failed to initialize card storage session. Please try again.';
					this.errors = [errorMessage];
				},
			});
	}

	@HostListener('window:message', ['$event'])
	onMessage(event: MessageEvent) {
		// Handle postMessage events from PracticePay iframe
		if (event.data?.type === 'CARD_STORED' || event.data?.result?.status === 'Authorised') {
			this.toasterService.showSavedSuccess();
			this.closeModal(true);
		} else if (event.data?.result?.status === 'Error') {
			this.errors = ['Card storage failed. Please try again.'];
		} else if (event.data?.type === 'CLOSE_IFRAME') {
			this.closeModal(false);
		}
	}

	onIframeLoad() {
		this.isLoading = false;
	}

	/* istanbul ignore next: closeModal */
	closeModal(cardSaved = false) {
		this.dynamicModalRef.close(this.modal, cardSaved);
	}
}
